// @flow

import { combineReducers, type Reducer } from 'redux';

import type { Currency } from '@gandi/cart';

import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
  type ListState,
  type ResourceAction,
} from '@gandi/resource/redux';

export type LegacySize = 's' | 's+' | 'm' | 'l' | 'xl' | 'xxl';
export type WebhostingSize =
  | 'essential'
  | 'starter'
  | 'advanced'
  | 'pro'
  | 'business';

export const legacySizes: $ReadOnlyArray<LegacySize> = [
  's',
  's+',
  'm',
  'l',
  'xl',
  'xxl',
];
export const webhostingSizes: $ReadOnlyArray<WebhostingSize> = [
  'essential',
  'starter',
  'advanced',
  'pro',
  'business',
];

export const webhostingSizesEssentialExcluded: $ReadOnlyArray<WebhostingSize> =
  ['starter', 'advanced', 'pro', 'business'];

export type Storage = 'storage';

export type InstanceSize = LegacySize | WebhostingSize | Storage;

export type SimplehostingPriceSummary = {
  currency: Currency,
  duration_unit: 'month',
  end_at?: string,
  max_duration: number,
  min_duration: number,
  price: number,
  price_after_taxes: number,
  price_before_taxes: number,
  product: {
    name: InstanceSize,
    params: {
      cpu: number,
      ram: number,
      storage: number,
      upgradable_storage_size: boolean,
    },
  },
  normal_price_after_taxes?: number,
  normal_price_before_taxes?: number,
  start_at: string,
  taxes: Array<{
    name: string,
    rate: number,
    type: string,
  }>,
};

export type State = {
  list: ListState<SimplehostingPriceSummary>,
};

export type PricesResourceType = SequoiaResourceType<{
  fetchResource: SimplehostingPriceSummary,
  fetchOneResource: empty,
}>;

export type PricesResource = SequoiaResource<PricesResourceType>;

export const shsPricesResource: PricesResource = createSequoiaResource(
  'simplehosting',
  'prices',
  {
    fetchPath: 'simplehosting/prices',
    getResourceId: resource =>
      `${resource.product.name}_${resource.min_duration}-${resource.max_duration}`,
  },
);

export const reducer: Reducer<State, ResourceAction<>> = combineReducers({
  ...shsPricesResource.listReducer,
});
